import { BillingCaptureMethod } from "../types/establishment/billingCaptureMethod";

export class BillingCaptureMethodsTransformer {
  static optionsTransformer() {
    return (captureMethods: BillingCaptureMethod[]) => {
      return captureMethods.map((captureMethod) => {
        return {
          value: captureMethod.id,
          label: captureMethod.display_name,
          perma_name: captureMethod.perma_name,
        };
      });
    };
  }
}
